import React from 'react';
import classnames from 'classnames';
import { isBrowser } from 'react-device-detect';

import FbIcon from 'images/icons/social-fb.svg';
import LineIcon from 'images/icons/social-line.svg';
import IgIcon from 'images/icons/social-ig.svg';
import TripadvisorIcon from 'images/icons/social-tripadvisor.svg';
import WeiboIcon from 'images/icons/social-weibo.svg';
import YoutubeIcon from 'images/icons/social-youtube.svg';

import styles from './index.css';

const SocialGroup = ({ className, lineLink, tripadvisorLink, fbLink, igLink, weiboLink, youtubeLink }) => (
	<div
		className={classnames(styles.socialGroup, className, {
			[styles.isBrowser]: isBrowser,
		})}
	>
		{fbLink && (
			<a href={fbLink} target="_blank" rel="noopener noreferrer">
				<span>
					<FbIcon />
				</span>
			</a>
		)}
		{lineLink && (
			<a href={lineLink} target="_blank" rel="noopener noreferrer">
				<span>
					<LineIcon />
				</span>
			</a>
		)}
		{igLink && (
			<a href={igLink} target="_blank" rel="noopener noreferrer">
				<span>
					<IgIcon />
				</span>
			</a>	
		)}
		{tripadvisorLink && (
			<a href={tripadvisorLink} target="_blank" rel="noopener noreferrer">
				<span>
					<TripadvisorIcon />
				</span>
			</a>
		)}
		{weiboLink && (
			<a href={weiboLink} target="_blank" rel="noopener noreferrer">
				<span>
					<WeiboIcon />
				</span>
			</a>
		)}
		{youtubeLink && (
			<a href={youtubeLink} target="_blank" rel="noopener noreferrer">
				<span>
					<YoutubeIcon />
				</span>
			</a>
		)}
	</div>
);

export default SocialGroup;



// WEBPACK FOOTER //
// ./src/components/molecules/SocialGroup/component.js